enum status {
  VERIFYING = "VERIFYING",
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  REJECTED = "REJECTED",
  ENDED = "ENDED",
}

export default status;
